module.exports = __webpack_public_path__ + "static/media/CosAssessmentsReport.deaca170.png";